import axios from "axios";
// import { Toast } from "vant";
import { message } from "ant-design-vue";

import { baseUrl } from "/env.js";
import { loginOut, createUuid } from "@/utils/function.js";
import store from "@/store"; 
import vue from "vue"
import router from "@/router/index.js";

const Base64 = require("js-base64").Base64;
const request = axios.create({
  // API 请求的默认前缀
  baseURL:
    process.env.NODE_ENV === "development"
      ? baseUrl
      : process.env.VUE_APP_BASE_API,
  timeout: 6000, // 请求超时时间
  headers: {
    "authorization-type": "BASIC_AUTH",
  },
});

// 异常拦截处理器
const errorHandler = (error) => {
  switch (error?.response?.status) {
    case 401:

    let path = router.currentRoute.value.fullPath; 
    let bool = [ "home", "notice", "myPage" ].some(item => path.includes(item))
    let key = "access_token"; 
    let delKey = "data/SET_USER_INFO"; 
      if(bool) {
        key = "access_token2"; 
        delKey = "data/SET_USER_INFO2"; 
      }
      
      if (localStorage.getItem(key)) {
        message.warn(
          Base64.decode(error?.response?.headers["x-error-msg"] || "")
        );
      }
      loginOut();
      store.commit(delKey, {})
      break;
    case 400:
    case 403:
    case 405:
    case 415:
    case 429:
    case 500:
      // 400-接口参数错误 401-未登录/登录过期 403-无请求接口权限 405-请求方式错误 415-请求参数格式错误 429-请求次数限制
      message.warn(
        Base64.decode(error?.response?.headers["x-error-msg"] || "")
      );

      break;
  }
  return Promise.reject(error.response);
};

// 请求拦截器
const requestHandler = (config) => {
  let path = router.currentRoute.value.fullPath; 
  let bool = [ "home", "notice", "myPage" ].some(item => path.includes(item))
  let key = bool ? "access_token2" : "access_token"; 

  const savedToken = localStorage.getItem(key); // 如果 token 存在
  // 让每个请求携带自定义 token, 请根据实际情况修改
  if (savedToken) {
    config.headers["X-Access-Token"] = savedToken;
  }
  

  let uuid = createUuid();
  config.headers["X-B3-TraceId"] = uuid.slice(0, 16);
  config.headers["X-B3-SpanId"] = uuid.slice(16, 32);
  return config;
}; // Add a request interceptor

request.interceptors.request.use(requestHandler, errorHandler);

// 响应拦截器
const responseHandler = ({ data, status }) => {
  switch (status) {
    case 201:
      message.success("新增成功");
      break;
    case 204:
      message.success("删除成功");
      break;
    case 205:
      message.success("修改成功");
      break;
  }
  return data;
}; // Add a response interceptor

request.interceptors.response.use(responseHandler, errorHandler);
export default request;
